import { AUTH_THEME } from '../../config/authAppearance';

export default function AuthLayout({ children }) {
  return (
    <div
      data-auth-theme={AUTH_THEME}
      className={`${AUTH_THEME} min-h-screen flex items-center justify-center bg-gradient-purple-blue relative overflow-hidden`}
      style={{ colorScheme: AUTH_THEME }}
    >
      <div className="bg-gradient-orb-1" aria-hidden="true" />
      <div className="bg-gradient-orb-2" aria-hidden="true" />
      <div className="relative w-full max-w-md px-4 py-10">
        <h1 className="text-heading-xl sm:text-display text-white text-center mb-6 sm:mb-8">
          TurboSync Pro
        </h1>
        {children}
      </div>
    </div>
  );
}
